import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-icon-flag-rus',
  templateUrl: './icon-flag-rus.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconFlagRusComponent {}
